const { get } = require('@ebay/str-ui-utils/retriever');
const { getEnv, getAnnouncementsBasePath, getUserPrefsBasePath } = require('@ebay/str-ui-utils/env');
const { request } = require('@ebay/str-ui-utils/ajax');
const announcementsMock = require('./services/announcement-provider/__mocks__/announcement-module-result.json');
const singleAnnouncementsMock = require(
    './services/announcement-provider/__mocks__/announcement-social-single-module.json');

module.exports = class {
    onCreate(input) {
        this.ANNOUNCEMENT_TYPES = {
            SINGLE: 1,
            MULTIPLE: 2
        };
        this.pageId = get(input, 'model.pageId', null);
        this.isMock = get(input, 'model.isMock', false);
        this.announcementType = get(input, 'model.announcementType', this.ANNOUNCEMENT_TYPES.MULTIPLE);
        this.env = getEnv();
        this.state = {
            announcementsModule: null,
            open: true
        };
    }

    closeModal() {
        this.state.open = false;
    }

    onMount() {
        if (this.pageId) {
            // pageId is the only required parameter
            this.getAnnouncements();
        }
    }

    async onClose(obj) {
        const { dontShowMeAgain, feature } = obj;
        this.setUserPreferences(dontShowMeAgain);
        await this.closeModalAsync();
        // emit the event for stores edit page
        if (feature) {
            this.emit('announce-feature', feature);
        }
    }

    async closeModalAsync() {
        return new Promise(resolve => {
            const announcementDialog = this.getComponent('str-announcement-confirm-dialog');
            const announcementDialogObserver = new MutationObserver((mutationsList, observer) => {
                mutationsList.forEach(mutation => {
                    if (mutation.target.hidden) {
                        observer.disconnect();
                        resolve();
                    }
                });
            });
            if (announcementDialog) {
                announcementDialogObserver.observe(announcementDialog.el, {
                    attributes: true,
                    attributeFilter: ['hidden']
                });
            }
            this.state.open = false;
        });
    }

    handleSuccessResponse(announcementModule) {
        if (get(announcementModule, 'modules.storeAnnouncementModule', null)) {
            this.state.announcementsModule = announcementModule.modules.storeAnnouncementModule;
        }
    }

    async handleErrResponse() {
        // fail silently, do not show the dialog at all
        await this.closeModalAsync();
    }

    getAnnouncements() {
        if (this.isMock === true && this.announcementType === this.ANNOUNCEMENT_TYPES.MULTIPLE) {
            this.state.announcementsModule = announcementsMock.modules.storeAnnouncementModule;
            return;
        } else if (this.isMock === true && this.announcementType === this.ANNOUNCEMENT_TYPES.SINGLE) {
            this.state.announcementsModule = singleAnnouncementsMock.modules.storeAnnouncementModule;
            return;
        }

        const endpoint = `?pageid=${this.pageId}`;
        const basePath = getAnnouncementsBasePath(this.env, this.pageId);
        request(basePath, endpoint)
            .then(this.handleSuccessResponse.bind(this))
            .catch(this.handleErrResponse.bind(this));
    }

    setUserPreferences(dontShowMeAgain) {
        /*  endpoint is not required in case of user preferences
            as this is determined dynamically in strmgtweb repo
            refer: src/api/seller-preference/index.js
        */
        // purposely passing endpoint as a space filled string to bypass validation in utils/ajax/index.js
        if (this.isMock) {
            // shouldn't mock this as this is not testable
            return;
        }

        const count = get(this.state, 'announcementsModule.sellerPreference.count', 0);
        const nextCount = parseInt(count) + 1;
        const id = get(this.state, 'announcementsModule.sellerPreference.key', null);
        const endpoint = `/${id}?cnt=${nextCount}&hide=${dontShowMeAgain}`;
        const basePath = getUserPrefsBasePath(this.env, this.pageId);
        request(basePath, endpoint)
            .then(this.handleSuccessResponse.bind(this))
            .catch(this.handleErrResponse.bind(this));
    }
};
